import { Contract, ContractEmployeesRequest, ContractRequest, Contracts, ContractsQueryParams } from "../model/Contract";
import { callAPI, getAuthenticatedGetUrl, HTTPMethod } from "./API";

const basePath = (tenantId: string) => `/tenants/${tenantId}/contracts`;

const buildParams = (params: ContractsQueryParams) => {
    return Object.fromEntries(
        Object.entries(params).filter(([key, value]) => {
            return value !== "" && value !== null && value !== undefined && (!Array.isArray(value) || value.length > 0);
        })
    );
};

const buildRequest = (request: ContractRequest) => {
    return {
        ...request,
        to: request.date_undetermined ? null : request.to,
    };
};

export async function listContracts(tenantId: string, params: ContractsQueryParams): Promise<Contracts> {
    return await callAPI(`${basePath(tenantId)}`, {
        method: HTTPMethod.GET,
        query: buildParams(params),
    });
}

export async function getContract(tenantId: string, contractId: string): Promise<Contract> {
    return await callAPI(`${basePath(tenantId)}/${contractId}`, {
        method: HTTPMethod.GET,
    });
}

export async function getDocumentUrl(tenantId: string, id: string): Promise<string> {
    return getAuthenticatedGetUrl(`${basePath(tenantId)}/${id}/document`);
}

export async function createContract(tenantId: string, request: ContractRequest): Promise<Contract> {
    return await callAPI(`${basePath(tenantId)}`, {
        method: HTTPMethod.POST,
        body: buildRequest(request),
    });
}

export async function updateContract(
    tenantId: string,
    contractId: string,
    request: ContractRequest
): Promise<Contract> {
    return await callAPI(`${basePath(tenantId)}/${contractId}`, {
        method: HTTPMethod.PUT,
        body: buildRequest(request),
    });
}

export async function closeContract(tenantId: string, contractId: string): Promise<Contract> {
    return await callAPI(`${basePath(tenantId)}/${contractId}/close`, {
        method: HTTPMethod.PUT,
    });
}

export async function deleteContractById(tenantId: string, contractId: string): Promise<Contracts> {
    return await callAPI(`${basePath(tenantId)}/${contractId}`, {
        method: HTTPMethod.DELETE,
    });
}

export async function updateEmployees(tenantId: string, contractId: string, request: ContractEmployeesRequest): Promise<Contract> {
    return await callAPI(`${basePath(tenantId)}/${contractId}/employees`, {
        method: HTTPMethod.PUT,
        body: request,
    });
}
